module.exports = __webpack_public_path__ + "static/tBTC –guide -15fcd40237f4c4dbfa2748471fdde638.jpg";